// react
import React, { useState, useEffect, useCallback } from "react";

// @mui
import { Grid, CircularProgress } from "@mui/material";

// features/customer/components
import CustomersTable from "features/customer/components/CustomersTable";
import CreateCustomerDialog from "features/customer/components/CreateCustomerDialog";

// firebase
import { db } from "config/firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";

// features/customer
import getCustomers from "features/customer/getCustomers";
import postCustomer from "features/customer/postCustomer";

// A ---------------------------------------------------------------------- M

const CustomerManagement = () => {
  const [clients, setClients] = useState([]);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const loadClients = useCallback(async () => {
    try {
      setIsLoading(true);
      const clientsList = await getCustomers();
      clientsList.sort((client1, client2) => client2.generationTimestamp - client1.generationTimestamp);
      setClients(clientsList);
    } catch (error) {
      console.error("Error loading clients:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadClients();

    const currentTimestamp = Math.floor(Date.now() / 1000).toString();
    const clientsCollectionRef = collection(db, "clientsdata");
    const newAdditionsQuery = query(clientsCollectionRef, where("generationTimestamp", ">=", currentTimestamp));

    const unsubscribe = onSnapshot(newAdditionsQuery, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          loadClients();
        }
      });
    });

    return () => unsubscribe();
  }, [loadClients]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCreateClient = async (newClientData) => {
    try {
      await postCustomer(newClientData);
      handleClose();
    } catch (error) {
      console.error("Error creating client:", error);
    }
  };

  if (isLoading) {
    return (
      <Grid container justifyContent="center" mt="30%">
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomersTable clients={clients} handleOpen={handleOpen} />
      </Grid>

      <CreateCustomerDialog open={open} handleClose={handleClose} handleCreateClient={handleCreateClient} />
    </Grid>
  );
};

export default CustomerManagement;
